import { useCallback } from 'react';
import { FormatNumberOptions, useIntl } from 'react-intl';

export type LocalizeCurrencyOptions = Omit<FormatNumberOptions, 'style' | 'currency'>;

export const useLocalizeCurrency = () => {
    const intl = useIntl();

    return useCallback(
        (value: number, currency: string, options?: LocalizeCurrencyOptions) =>
            intl.formatNumber(value, {
                style: 'currency',
                currency,
                ...options,
            }),
        [intl]
    );
};
